import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProfileService } from '../../../../services/profile.service';
import { patterns } from '../../../../../assets/patterns';

@Component({
  selector: 'change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.css']
})
export class ChangePasswordModalComponent implements OnInit {

  changePasswordForm: UntypedFormGroup;
  password: any;
  loading: boolean = false;
  msgType = -1;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    private formBuilder: UntypedFormBuilder,
    private profileService: ProfileService
  ) { }

  ngOnInit(): void {
    this.changePasswordForm = this.formBuilder.group({
      email: [JSON.parse(sessionStorage.getItem('userDetails')).email],
      oldPassword: ['', Validators.required],
      password: ['', [Validators.required, Validators.pattern(patterns.passwordPattern)]],
      confPassword: ['', Validators.required],
    });
  }

  onNoClick(): void {
    this.dialogRef.close(0);
  }

  changePassword() {
    this.msgType = -1;
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return false;
    }
    this.loading = true;
    this.profileService.changeUserPassword(this.changePasswordForm.value).subscribe((res: any) => {
      this.loading = false;
      if (res === 1) {
        this.dialogRef.close(1);
      } else {
        this.msgType = res;
      }
    }, (error) => {
      this.loading = false;
      console.error('ChangePasswordModalComponent_changePassword', error);
    });

  }

}
